import { z } from 'zod/v3';
import { makeFieldSchemaFromZod } from '../utils';

/* All uiSchema options — in the template they go under ui:options: */
export const InputGroupCheckboxCardUiOptionsSchema = z.object({
  // Info alert text shown above the checkbox
  infoText: z.string().optional(),
  // Label for the checkbox (e.g. "Replace API Key")
  checkboxLabel: z.string().optional(),
  // The property key for the field gated by the checkbox
  secretField: z.string().optional(),
  // Whether the checkbox-gated field is a secret (shows password toggle)
  isSecret: z.boolean().optional(),
});

// Transforms the Zod schema to a TypeScript type
export type InputGroupCheckboxCardUiOptions = z.infer<
  typeof InputGroupCheckboxCardUiOptionsSchema
>;

/* The field schema for the InputGroupCheckboxCard field extension */
export const InputGroupCheckboxCardSchema = makeFieldSchemaFromZod(
  z.object({}).describe('Input Group Checkbox Card'),
  InputGroupCheckboxCardUiOptionsSchema,
);

// Transforms the field schema props to a TypeScript type
export type InputGroupCheckboxCardProps =
  typeof InputGroupCheckboxCardSchema.type;

/* The final schema used for the field extension */
export const InputGroupCheckboxCardSchemaFinal =
  InputGroupCheckboxCardSchema.schema;
